module.exports = __webpack_public_path__ + "media/images/map/arrived-map-9936a0ac6b9ed9acb8bc33ae9af74bd9.png";